import { Text, TextProps } from '@shared/components'

type Props = {
  condition: boolean
} & TextProps

export const ConditionalText = ({
  condition,
  children,
  style,
  ...props
}: Props) => {
  return (
    <Text style={{ wordBreak: 'normal', ...style }} {...props}>
      {condition && children ? children : '-'}
    </Text>
  )
}
